let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i35Uh")).then(() => parcelRequire('ccKWN'));